/* eslint-disable */
import React from "react";
import styles from "./ChannelList.module.css";
import { ProgramDetail } from "../../../stores/program/model/Program";
import PuiTypography from "../../../components/elements/PuiTypography";
import ChannelVideoCard from "./ChannelVideoCard";
import ChannelMainCard from "./ChannelMainCard";
import RedRightArrowIcon from "../images/RedRightArrowIcon";
import useResponsive from "../../../common/useResponsive";

export interface ChannelListProps {
  // チャンネル
  channel: ProgramDetail;
  // セレクトエリア用コールバック関数
  onCallback: any;
}

export default function ChannelList({ channel, onCallback }: ChannelListProps) {
  const handleClick = (id: string) => {
    onCallback(id);
  };
  const { isMobile } = useResponsive();
  return (
    <div key={`ChannelList-${channel.id}`} className={styles.container}>
      <div className={styles.titleRow}>
        <div className={styles.title} onClick={() => handleClick(channel.id)}>
          <PuiTypography size={isMobile ? 16 : 20} bold={true}>
            {channel.title}
          </PuiTypography>
        </div>
        <div className={styles.rightArrowIcon} onClick={() => handleClick(channel.id)}>
          <RedRightArrowIcon />
        </div>
      </div>
      <div className={styles.list}>
        {channel.videos.length > 0 &&
          channel.videos
            .slice(0, 1)
            .map((video) => <ChannelMainCard key={video.id} video={video} />)}
        {channel.videos.length > 1 &&
          channel.videos
            .slice(1, 4)
            .map((video) => <ChannelVideoCard key={video.id} video={video} />)}
      </div>
    </div>
  );
}
